const KeyLibrarySearch = (items, searchTerm) => {
  if (!searchTerm) return items;

  const createCompareString = (item) => {
    const itemName = item.name || '';
    const itemNameNoSpecialCharacters = itemName.replace(/[^a-zA-Z0-9 ]/g, ' ').toLowerCase();
    const bundleName = item.bundleName || '';
    const bundleNameSpecialCharacter = bundleName.replace(/[^a-zA-Z0-9 ]/g, ' ').toLowerCase();

    return `${itemName} ${itemNameNoSpecialCharacters} ${bundleName} ${bundleNameSpecialCharacter}`;
  };


  return items.filter((item) => {
    const itemCompareString = createCompareString(item);
    return itemCompareString.includes(searchTerm);
  });
};

export default KeyLibrarySearch;
